import { Box, BoxProps } from "@mui/material"
import React from "react"

// https://framer.com/projects/Framer-SaaS-Website-Kit-copy--qTuNvqpfJw7vRJ9mXM5S-8JxUw?utm_campaign=saas_kit&node=Rk9u34P9g
export function FramerImage({ id, sx, ...rest }: { id: string } & BoxProps) {
  return (
    <Box
      sx={{
        aspectRatio: "1 / 1",
        filter: "drop-shadow(0px 50px 26px rgba(163, 71, 189, .4))",
        width: { lg: 276, sm: 148, xs: 100 },
      }}
    >
      <Box
        component="img"
        sx={{
          borderRadius: "inherit",
          display: "block",
          height: "100%",
          imageRendering: "auto",
          objectFit: "cover",
          objectPosition: "center center",
          width: "100%",
          ...sx,
        }}
        decoding="async"
        loading="lazy"
        sizes="max((min(100vw, 1600px) - 180px) / 6, 50px)"
        srcSet={`https://framerusercontent.com/images/${id}.png?scale-down-to=512 512w, https://framerusercontent.com/images/${id}.png?scale-down-to=1024 1024w, https://framerusercontent.com/images/${id}.png 1500w`}
        src={`https://framerusercontent.com/images/${id}.png`}
        alt=""
        {...rest}
      />
    </Box>
  )
}
